import type { Logger } from '@/scopes/common/domain/types'

export function createConsoleLogger(): Logger {
  function logError(error: Error, info?: { [key: string]: unknown }) {
    if (info)
      console.error(error, info)
    else
      console.error(error)
  }

  function logEvent(name: string, info?: { [key: string]: unknown }) {
    /* eslint-disable no-console */
    if (info)
      console.log(name, info)
    else
      console.log(name)
    /* eslint-enable no-console */
  }

  function setContext() {}

  return {
    logError,
    logEvent,
    setContext,
  }
}
